import apiSnapshot from '../../apis/apiSnapshot.mjs'
import parseMap from '../../scripts/parseMap.mjs'
import readProject from '../readProject.mjs'

export default pkid => {
    return async () => {
        const mapData = await apiSnapshot.read({pkid})
        const initData = parseMap(mapData)
        const {desgAcc} = await readProject(initData.data.prjId)
        Object.assign(initData.data, {desgAcc})
        return initData
    }
}
